import React, { useEffect, useState } from "react";
import { UserPlus, X, Copy, Check, Gift } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function InviteFriend() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    api
      .get("/me/referrals")
      .then(({ data }) => setData(data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, [open]);

  const link = data ? `${window.location.origin}/login?ref=${data.code}` : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Invite link copied — share it anywhere!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — select and copy the link manually.");
    }
  };

  const share = async () => {
    const text = "Track your OSRS grind & win a free Bond on TaskScape — join me:";
    try {
      if (navigator.share) await navigator.share({ title: "TaskScape", text, url: link });
      else await copy();
    } catch {}
  };

  return (
    <>
      <button data-testid="open-invite" onClick={() => setOpen(true)} className="osrs-btn px-3 py-2 text-sm flex items-center gap-2" title="Invite a friend">
        <UserPlus size={16} className="text-[#7CFC7C]" /> <span>Invite</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4" onClick={() => setOpen(false)}>
          <div className="osrs-panel p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="invite-modal">
            <div className="flex items-center justify-between mb-4">
              <h3 className="osrs-title text-2xl flex items-center gap-2"><UserPlus size={20} className="text-[#7CFC7C]" /> Invite a friend</h3>
              <button onClick={() => setOpen(false)} className="osrs-btn px-2 py-1" data-testid="close-invite"><X size={16} /></button>
            </div>

            <div className="flex items-start gap-3 bg-[#1c2a16] border border-[#3f6a2a] p-3 mb-4">
              <Gift size={20} className="text-[#7CFC7C] shrink-0 mt-0.5" />
              <p className="osrs-shadow text-[#E6A519] text-sm leading-snug">
                When a friend signs up with your link, <span className="text-[#7CFC7C] font-bold">you both get +1 free skip</span>. Bring the whole clan!
              </p>
            </div>

            <label className="osrs-shadow text-xs text-[#b9a06a] block mb-1 uppercase">Your invite link</label>
            <div className="flex gap-2 mb-4">
              <input
                data-testid="invite-link-input"
                readOnly
                value={link}
                onFocus={(e) => e.target.select()}
                className="osrs-input flex-1 px-3 py-2 text-sm min-w-0"
              />
              <button data-testid="copy-invite-btn" onClick={copy} className="osrs-btn px-3 py-2 flex items-center gap-1 shrink-0">
                {copied ? <Check size={16} className="text-[#7CFC7C]" /> : <Copy size={16} />}
              </button>
            </div>

            <div className="flex items-center justify-between">
              <span className="osrs-shadow text-sm text-[#E6A519]" data-testid="invite-count">
                Friends joined: <span className="osrs-num text-[#FFCF3F]">{data?.count ?? 0}</span>
              </span>
              <button data-testid="share-invite-btn" onClick={share} className="osrs-btn osrs-btn-green px-4 py-2 text-sm">Share link 📣</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
